module.exports = {"addTag":"+ Añadir etiqueta","add":"Añadir","close":"Cerrar","tagPlaceholder":"Introducir etiqueta..."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Tags/localization/es-ES/strings.json
// module id = 1200
// module chunks = 0